module.exports = __webpack_public_path__ + "img/icon-57.5a3c90b4.svg";